import t from '../actions/actionTypes'

const defaultState = {
	selectedMainTab: '',
	selectedEmbedRadio: '',
	payload: '',
}

function setFolderData(state, action) {
	const { messageNoHtml, subjectNoHtml } = action.payload
	return {
		...state,
		payload: {
			...action.payload,
			email: {
				subject_plain: subjectNoHtml,
				message_plain: messageNoHtml,
			},
		},
	}
}

const shareReducer = (state = defaultState, action) => {

	switch (action.type) {
		case t.MY_LIBRARY_SHARE_FOLDER_DATA_LOADED:
			return setFolderData(state, action)
		case t.SHARE_VIEW_DATA_LOADED:
			return Object.assign({}, state, {
				payload: action.payload,
			})
		case t.SHARE_CHANGE_MAIN_TAB:
			return Object.assign({}, state, {
				selectedMainTab: action.selectedTab,
			})
		case t.SHARE_CHANGE_EMBED_TAB:
			return Object.assign({}, state, {
				selectedEmbedRadio: action.selectedTab,
			})
		case t.MY_LIBRARY_SHARE_LESSON:
			return {
				...defaultState,
				selectedMainTab: 'link',
				selectedEmbedRadio: 'Small',
			}
		case t.MY_LIBRARY_SHARE_FOLDER:
		case t.STORE_SEARCH_SHARE_LESSON:
		case t.STOREFRONT_SHARE:
			return {
				...defaultState,
				selectedMainTab: 'email',
				selectedEmbedRadio: 'Small',
			}
		default:
			return state
	}
}

export default shareReducer
